import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";

import { Tags } from "src/elements";
import { useTranslation } from "src/i18n";
import { formatDimension } from "src/utils/formatDimension";
import { shelfWeightRows } from "src/components/Planogram/common/shelfWeightLabel";
import {
  formatMerchandisableSpace,
  getMerchandisableSpaceInfo,
} from "src/components/Planogram/common/merchandisableSpace";

interface Props {
  shelf: PlanogramShelf;
  isShelfWeightEnabled: boolean;
}

export const ShelfDetails = ({ shelf, isShelfWeightEnabled }: Props) => {
  const { t } = useTranslation("common");
  const mergedWidth = shelf.getMergedWidth();
  const unusedWidth = shelf.getUnusedWidth();
  const merchandisableSpace = getMerchandisableSpaceInfo(shelf);

  return (
    <Tags
      tags={[
        { label: "Shelf", value: shelf.getName() },
        { label: "X", value: formatDimension(shelf.getXLeft()) },
        { label: "Y", value: formatDimension(shelf.getYBottom()) },
        { label: "Notch No", value: shelf.getNotchNo() },
        { label: "Width", value: formatDimension(mergedWidth) },
        { label: "Height", value: formatDimension(shelf.thickness) },
        { label: "Depth", value: formatDimension(shelf.depth) },
        { label: "Available Space", value: formatDimension(unusedWidth) },
        ...(isShelfWeightEnabled ? shelfWeightRows(shelf, t) : []),
        ...(merchandisableSpace
          ? [
              {
                label: "Merchandisable Space",
                value: formatMerchandisableSpace(merchandisableSpace),
              },
            ]
          : []),
      ]}
    />
  );
};
